import React from 'react';
import { stylesColors as colors } from 'angieslist-styles';
import { Track, urlCatalog } from 'angieslist-app-platform';
import UserFlyout from './UserFlyout';
import AuthHeaderSideBar from './AuthHeaderSideBar';
import logo from './AngiAdsBusinessCenter.png';
import './authHeaderConfig.scss';

const headerIconStyle = {
  fontSize: '1.35em',
  color: colors.textBodyDark,
  top: '15px',
};

const navItemStyle = { padding: '0 10px' };

const intercomAssistance = (
  <span key="auth-header-right-nav--intercom-help" style={navItemStyle}>
    <Track>
      <a
        id="auth-header-right-nav--intercom-help-link"
        data-track-description="Articles & FAQs"
        href={urlCatalog.global.intercomAssistance()}
        target="_blank"
        rel="noopener noreferrer"
      >Articles & FAQs
      </a>
    </Track>
  </span>
);

const rightNavItems = [
  (
    <span key="auth-header-right-nav--angieslist" style={navItemStyle}>
      <Track>
        <a
          id="auth-header-right-nav--angieslist-link"
          data-track-description="Visit Member Site"
          href={urlCatalog.global.angiesListHome()}
        >Angi.com
        </a>
      </Track>
    </span>
  ), (
    <UserFlyout iconStyle={headerIconStyle} key="userFlyout" />
  ),
];

export default (isAdvertiser) => {
  const headerConfig = {
    logo,
    homeLink: '/',
    rightNavItems: isAdvertiser ? [intercomAssistance, ...rightNavItems] : [...rightNavItems],
    sideBarMenu: [
      (<AuthHeaderSideBar key="auth-side-bar" isAdvertiser={isAdvertiser} />),
    ],
  };

  return headerConfig;
};



// WEBPACK FOOTER //
// ./src/app/browser/header/authHeaderConfig.js